import type { CMSAccordionDTO } from "~/CMSComponents/dto";
import { renderCMSComponent } from "~/CMSComponents/componentFactory";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

interface Props extends Omit<CMSAccordionDTO, "type"> {
  className?: string;
}

export const CMSAccordion = (props: Props) => {
  return (
    <Accordion defaultExpanded={props.openByDefault}>
      <AccordionSummary>{props.title}</AccordionSummary>
      <AccordionDetails>
        {props.accordionBody.map((content, index) => {
          return renderCMSComponent(content, undefined, index);
        })}
      </AccordionDetails>
    </Accordion>
  );
};
